var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79098 1.54992C2.60446 1.13483 2.40795 1.12643 2.22983 1.11907C2.08429 1.11277 1.91826 1.11329 1.75222 1.11329C1.58619 1.11329 1.31613 1.17582 1.08757 1.42539C0.859009 1.67497 0.214844 2.27762 0.214844 3.50395C0.214844 4.73029 1.10806 5.91564 1.23258 6.08167C1.35711 6.2477 2.95701 8.84485 5.49059 9.8442C7.59595 10.6744 8.02469 10.5094 8.48181 10.4679C8.93892 10.4264 9.95667 9.86522 10.1642 9.28305C10.3717 8.70089 10.3717 8.20226 10.3097 8.09823C10.2472 7.9942 10.0812 7.9322 9.83214 7.80715C9.58309 7.6821 8.35728 7.07944 8.12873 6.99642C7.90017 6.91341 7.73414 6.8719 7.56758 7.12147C7.40154 7.37052 6.92394 7.9322 6.7784 8.09823C6.63285 8.26479 6.48731 8.28581 6.23826 8.16076C5.98921 8.03571 5.18637 7.773 4.23378 6.92392C3.49294 6.26346 2.99274 5.44749 2.8472 5.19791C2.70166 4.94886 2.83144 4.81383 2.95649 4.6893C3.0684 4.57739 3.20554 4.39822 3.33059 4.25268C3.45511 4.10714 3.49662 4.0031 3.57964 3.83707C3.66265 3.67051 3.62114 3.52497 3.55862 3.40045C3.49715 3.2754 3.01271 2.04276 2.79098 1.54992Z",
    fill: "#F9C416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.44e8fab1a6f2698784e3c141d8d0228b.svg";
export { ForwardRef as ReactComponent };